import { LEGAL_DOCUMENT_PATHS } from '@provision/landing-page-utils';
import type { LegalDocumentSurface } from 'src/pages/Settings/memberships/hooks/use-legal-document-surface';
import { useSegmentBaseUrl } from 'src/pages/Settings/memberships/hooks/use-segment-base-url';

/** Undefined until the document is saved. */
export const useLegalDocumentLiveUrl = (
  partnerId: number | null,
  brandId: string | undefined,
  surface: LegalDocumentSurface | null,
): string | undefined => {
  const baseUrl = useSegmentBaseUrl(surface ? partnerId : null, brandId);

  return baseUrl && surface?.savedDocument
    ? `${baseUrl}${LEGAL_DOCUMENT_PATHS[surface.kind]}`
    : undefined;
};
